import { ClearIcon, EyeIcon, EyeOffIcon, SpinnerIcon } from '@shared/components/icons/icons'
import { Settings } from 'superlikers-dynamic-forms'

export const settings: Settings = {
  wrapperClasses: 'flex flex-col gap-1 text-left relative',
  labelClasses: 'text-preset-4-bold text-theme-dark-gray/60',
  errorClasses: 'text-preset-5 text-theme-red',
  helpTextClasses: 'text-theme-dark-gray/60 text-preset-5',
  inputClasses:
    'placeholder:text-theme-dark-gray/60 focus:border-theme-dark-gray h-10 w-full border border-transparent rounded-full focus:border px-6 leading-none focus:outline-none transition-colors duration-200 bg-theme-light-gray disabled:text-theme-dark-gray/60',
  passwordEyeOpenIcon: EyeIcon,
  passwordEyeCloseIcon: EyeOffIcon,
  passwordIconClasses: 'w-5 h-5 text-gray-500 hover:text-gray-700 cursor-pointer transition-colors absolute right-4 top-9',
  // Select controls
  selectClasses:
    'placeholder:text-theme-dark-gray/60 focus:border-theme-dark-gray h-10 w-full border border-transparent rounded-full focus:border px-6 leading-none focus:outline-none transition-colors duration-200 bg-theme-light-gray',
  // Checkbox controls
  checkboxWrapperClasses: 'flex items-center gap-2',
  checkboxInputClasses: 'w-4 h-4 text-black bg-white rounded transition-all duration-150 cursor-pointer accent-theme-yellow',
  checkboxLabelTextClasses: 'text-sm text-gray-900 cursor-pointer select-none',
  // autocomplete controls
  autocompleteInputClasses:
    'disabled:opacity-50 placeholder:text-theme-dark-gray/60 focus:border-theme-dark-gray h-10 w-full border border-transparent rounded-full focus:border px-6 leading-none focus:outline-none transition-colors duration-200 bg-theme-light-gray',
  autocompleteDropdownClasses: 'bg-white border border-gray-200 rounded-md shadow-lg max-h-60 min-w-60 overflow-auto mt-1 p-2',
  autocompleteDropdownItemClasses: 'py-2 px-3 hover:bg-theme-gray-dark cursor-pointer transition-colors duration-150 text-preset-4',
  autocompleteDropdownItemHoverClasses: 'bg-theme-gray-dark',
  autocompleteDropdownItemSelectedClasses: 'bg-theme-gray-dark font-medium',
  autocompleteLoadingIcon: SpinnerIcon,
  autocompleteLoadingIconClasses: 'w-3.5 h-3.5 text-gray-500',
  autocompleteLoadingWrapperClasses: 'absolute right-3 top-1/2 -translate-y-1/2',
  autocompleteClearIcon: ClearIcon,
  autocompleteClearIconClasses: 'w-3.5 h-3.5 text-theme-red cursor-pointer absolute right-3 top-1/2 -translate-y-1/2'
}
